import useAuthState from '@/states/auth.state';
import useTenantState from '@/states/tenant.state';
import { axiosInstance } from '@/utils/lib/axios';
import { Spinner } from 'alurkerja-ui';
// import { useKeycloak } from 'keycloak-react-web';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

type ProtectedRouteProps = {
  layout: React.FC;
};

export const ProtectedGlobalRoute: React.FC<ProtectedRouteProps> = ({ layout: Layout }) => {
  const navigate = useNavigate();
  const { token, tenants, loadUserProfile, isLogoutLoading } = useAuthState();
  const { currentTenant } = useTenantState();

  useEffect(() => {
    const initializeUserProfile = async () => {
      if (token) {
        try {
          await loadUserProfile(token, true);
        } catch (error) {
          console.error('Failed to load user profile:', error);
        }
      }
    };

    initializeUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (!token) {
      console.error('No token found, redirecting to login');
      navigate('/login');
      return;
    }

    // Redirect to verify-email if email is not verified
    const userProfile = useAuthState.getState().userProfile;
    if (userProfile && !userProfile.email_verified_at) {
      navigate('/verify-email');
      return;
    }

    axiosInstance.interceptors.request.use(config => {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['Content-Type'] = 'application/json';
      return config;
    });

    const currentUrl = window.location.href;

    if (currentUrl.includes('/invitation') || currentUrl.includes('/export-all-workspaces')) {
      console.log('Invitation or export link detected — skip redirect');
      return;
    }

    if (currentTenant && currentTenant.slug && currentTenant.slug !== 'undefined' && currentTenant.slug !== 'null') {
      axiosInstance.defaults.headers.common['X-ACTIVE-TENANT'] = currentTenant.slug;
      navigate(`/${currentTenant.slug}`);
    } else {
      console.error('Current Tenant is not defined');
      navigate(`/workspaces`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, currentTenant, tenants]);

  if (token) {
    return (
      <>
        <Layout />

        <ToastContainer />
      </>
    );
  }

  if (isLogoutLoading) {
    return (
      <div className="fixed flex items-center justify-center w-screen h-screen gap-2">
        <Spinner className="text-primary" />
        Logout...
      </div>
    );
  }

  return (
    <div className="fixed flex items-center justify-center w-screen h-screen gap-2">
      <Spinner className="text-primary" />
      Loading...
    </div>
  );
};
